import { defineStore } from 'pinia'
import apiCall from '$/plugins/axios'

export const useFeatureStore = defineStore('feature', {
  state: () => ({
    features: [],
    feature: null,
    featureLimits: [],
    featureLimit: null,
    previewStatuses: [],
    images: [],
    imageData: [],
    results: [],
    currentSaveFolder: null,
    resultSaveFolder: null,
    progressModal: null,
    processing: false,
    disableSubmit: false,
    taskOptions: {
      size: 'small',
    },
    options: {
      'face-swap': {
        faceImage: null,
        manyFaces: false,
        nsfw: false,
      },
      'upscale-and-enhance-image': {
        version: '1.4',
        upscale: 2,
      },

      'restore-old-photo': {
        highResolution: true,
        withScratch: true,
      },

      'colorize-black-and-white-photo': {},

      'remove-background': {
        mode: 'fast',
      },

      'detect-face': {
        detectionLevel: 'high',
      },

      'blur-background': {},

      'blur-face': {},

      'trim-transparent-pixels': {},

      'image-shadow-generator': {
        xOffset: 20,
        yOffset: 20,
        sigma: 20.0,
        opacity: 80,
        color: '#000000',
      },

      'crop-image': {
        lockRatio: false,
      },

      'compress-image': {
        convertToWebp: false,
        resizeWidth: null,
      },

      'resize-image': {
        resizeType: 'pixel',
        keepRatio: true,
        resizeWidth: null,
        resizeHeight: null,
        resizePercentage: 50,
      },

      'photo-to-anime-converter': {
        model: 'style1',
      },

      'convert-image': {
        convertTo: 'PNG',
      },

      'rotate-image': {
        rotateAngle: 0,
        flipType: null,
      },
    },
  }),

  actions: {
    fetchFeatureLimits() {
      return new Promise((resolve, reject) => {
        apiCall
          .get('/features/limit')
          .then((res) => {
            this.featureLimits = res.data
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    fetchFeatures() {
      return new Promise((resolve, reject) => {
        apiCall
          .get('/features')
          .then((res) => {
            this.features = res.data
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    fetchFeature(slug) {
      return new Promise((resolve, reject) => {
        apiCall
          .get(`/features/${slug}`)
          .then((res) => {
            this.feature = res.data
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    execute(slug) {
      return new Promise((resolve, reject) => {
        this.results = []
        const formData = new FormData()
        Object.values(this.images).forEach((v) => formData.append('images[]', v))
        // Ensure each nested JSON object is stringified
        Object.keys(this.options[slug]).forEach((k) => {
          const value = this.options[slug][k]
          if (value instanceof File) {
            formData.append(`options[${k}]`, value)
          } else if (typeof value === 'object') {
            formData.append(`options[${k}]`, JSON.stringify(value))
          } else {
            formData.append(`options[${k}]`, value)
          }
        })
        Object.keys(this.taskOptions).forEach((k) => {
          formData.append(`taskOptions[${k}]`, this.taskOptions[k])
        })
        apiCall
          .post(`/features/${slug}`, formData)
          .then((res) => {
            if (this.taskOptions.asyncTask === true || this.taskOptions.bulkTask) {
              if (res.data?.status === 'error') {
                reject()
              } else {
                resolve(true)
              }
            } else {
              this.results = res.data.results
              this.resultSaveFolder = res.data.save_folder
              resolve(res)
            }
          })
          .catch((err) => {
            reject(err)
          })
          .finally(() => {
            if (!this.taskOptions.asyncTask === true && !this.taskOptions.bulkTask) this.processing = false
          })
      })
    },
  },

  getters: {
    popularFeatures: (state) => state.features.filter((i) => i.popular),
    otherFeatures: (state) => state.features.filter((i) => !i.popular),
  },
})
